import { LICENSE_TYPE_DEFS, hasOwnProperty } from '../../tn.common';

tnCartUpgradeText.$inject = ['$filter'];
export function tnCartUpgradeText($filter) {
    return {
        scope: {
            rightType: '=',
            right: '=',
            upgradeFrom: '=',
        },
        link: function (scope) {
            scope.$watch('upgradeFrom', (upgradeFrom) => {
                if (
                    upgradeFrom &&
                    hasOwnProperty(upgradeFrom, 'fontRights') &&
                    hasOwnProperty(upgradeFrom.fontRights, scope.rightType)
                ) {
                    updateText();
                } else {
                    scope.res =
                        'Loading... <span class="icon-upgrade-arrow"></span> ' +
                        getAdditionalYears(scope.right.years) +
                        ', ' +
                        getQty(scope.right, scope.rightType);
                }
            });

            scope.$watchCollection('right', () => {
                if (scope.upgradeFrom !== undefined) {
                    updateText();
                }
            });

            function updateText() {
                const originalEnd =
                    scope.upgradeFrom.fontRights[scope.rightType].end ||
                    'Perpetual';
                const originalYears =
                    scope.upgradeFrom.fontRights[scope.rightType].years;
                if (scope.right.upgrade && scope.right.renew) {
                    scope.res =
                        '<span class="strikeout">' +
                        $filter('date')(originalEnd, 'shortDate') +
                        ', ' +
                        textWithDefault(
                            getQty(
                                scope.upgradeFrom.fontRights[scope.rightType],
                                scope.rightType
                            ),
                            getTrial(scope.rightType, originalYears)
                        ) +
                        '</span> <span class="icon-upgrade-arrow"></span> ' +
                        '<div class="visible_break3__inlineblock license-new-terms">' +
                        getNewDate(
                            originalEnd,
                            originalYears,
                            scope.right.years
                        ) +
                        ', ' +
                        getQty(scope.right, scope.rightType) +
                        '</div>';
                } else if (scope.right.upgrade) {
                    // Upgrading ePub or Desktop license without expiration date
                    if (
                        scope.rightType === 'epub' ||
                        scope.rightType === 'desktop'
                    ) {
                        scope.res =
                            '<span class="strikeout">' +
                            textWithDefault(
                                getQty(
                                    scope.upgradeFrom.fontRights[
                                        scope.rightType
                                    ],
                                    scope.rightType
                                ),
                                getTrial(scope.rightType, originalYears)
                            ) +
                            '</span> <span class="icon-upgrade-arrow"></span> ' +
                            '<div class="visible_break3__inlineblock license-new-terms">' +
                            getQty(scope.right, scope.rightType) +
                            '</div>';
                    } else {
                        scope.res =
                            $filter('date')(originalEnd, 'shortDate') +
                            ', ' +
                            '<span class="strikeout">' +
                            textWithDefault(
                                getQty(
                                    scope.upgradeFrom.fontRights[
                                        scope.rightType
                                    ],
                                    scope.rightType
                                ),
                                getTrial(scope.rightType, originalYears)
                            ) +
                            '</span> <span class="icon-upgrade-arrow"></span> ' +
                            '<div class="visible_break3__inlineblock license-new-terms">' +
                            getQty(scope.right, scope.rightType) +
                            '</div>';
                    }
                } else if (scope.right.renew) {
                    scope.res =
                        '<span class="strikeout">' +
                        $filter('date')(originalEnd, 'shortDate') +
                        textWithDefault(
                            '',
                            getTrial(scope.rightType, originalYears, '', ', '),
                            ', '
                        ) +
                        '</span> <span class="icon-upgrade-arrow"></span> ' +
                        '<div class="visible_break3__inlineblock license-new-terms">' +
                        getNewDate(
                            originalEnd,
                            originalYears,
                            scope.right.years
                        ) +
                        ', ' +
                        getQty(scope.right, scope.rightType) +
                        '</div>';
                }
            }

            function getAdditionalYears(years) {
                if (years === 'unlimited' || years === -1) {
                    return 'Perpetual';
                } else if (years === 1) {
                    return '+ 1 year';
                } else {
                    return '+ ' + years + ' years';
                }
            }

            function getNewDate(oldDate, oldYears, yearsToAdd) {
                if (oldDate === null || yearsToAdd === 'unlimited') {
                    return 'Perpetual';
                }
                let newDate =
                    new Date(oldDate) < new Date()
                        ? new Date()
                        : new Date(oldDate);
                // treat renewing free trials and downgrading perpetual as starting from the current day
                if (oldYears === -2 || oldYears === -1) {
                    newDate = new Date();
                }
                newDate = new Date(
                    newDate.getUTCFullYear() + yearsToAdd,
                    newDate.getUTCMonth(),
                    newDate.getUTCDate()
                );
                return $filter('date')(newDate, 'shortDate');
            }

            function _setQty(right) {
                let qty = right.qty;
                if (scope.upgradeFrom) {
                    qty =
                        right.views ||
                        right.apps ||
                        right.computers ||
                        right.ebooks ||
                        qty;
                }
                return qty;
            }

            function getQty(right, rightType) {
                let text = '';
                const qty = _setQty(right);
                if (qty === -1) {
                    text += 'unlimited';
                } else if (qty) {
                    text += qty.toLocaleString();
                } else {
                    text +=
                        right[
                            LICENSE_TYPE_DEFS[rightType].key
                        ].toLocaleString();
                }
                // The label is too long if we show "page views per month" twice
                if (qty && rightType === 'web') {
                    text += ' ' + LICENSE_TYPE_DEFS[rightType].short;
                } else {
                    text += ' ' + LICENSE_TYPE_DEFS[rightType].label;
                }
                if (
                    rightType !== 'web' &&
                    (right[LICENSE_TYPE_DEFS[rightType].key] > 1 ||
                        right[LICENSE_TYPE_DEFS[rightType].key] ===
                            'unlimited' ||
                        qty > 1 ||
                        qty === 'unlimited')
                ) {
                    text += 's';
                }
                return text;
            }

            function getTrial(right, oldYears) {
                if (right === 'web' && oldYears === -2) {
                    return 'Free trial';
                }
                return '';
            }

            function textWithDefault(
                defaultText,
                targetText,
                prependText = ''
            ) {
                if (targetText) {
                    return prependText + targetText;
                }
                return defaultText;
            }
        },
        template: '<span ng-bind-html="res"></span>',
    };
}
